module.exports = "/images/vendor/flag-icon-css/flags/4x3/im.svg?8c10222d11a27a76e0bb29224c6f743c";